//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    name: "AQDefaultState",
    props: {
        showDefaultTitleImg: {
            type: Boolean,
            default: true
        },
        title: {
            type: String,
            default: ""
        },
        description: {
            type: String,
            default: ""
        }
    },
    computed: {
        getTitle() {
            return this.title || this.$t("defaultState.title");
        },
        getDescription() {
            return this.description || this.$t("defaultState.description");
        }
    }
};
